module.exports = __webpack_public_path__ + "static/img/server17.0ca50c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/server17.png
// module id = WOPy
// module chunks = 1